import { render, staticRenderFns } from "./rightcard3.vue?vue&type=template&id=a3726118&scoped=true"
import script from "./rightcard3.vue?vue&type=script&lang=js"
export * from "./rightcard3.vue?vue&type=script&lang=js"
import style0 from "./rightcard3.vue?vue&type=style&index=0&id=a3726118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3726118",
  null
  
)

export default component.exports